module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "box box-primary"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.dados.data),
      expression: "dados.data"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "month"
    },
    domProps: {
      "value": (_vm.dados.data)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.dados, "data", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-md-7"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.dados.pesquisa),
      expression: "dados.pesquisa"
    }],
    ref: "filtro_pesquisa",
    staticClass: "form-control",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "placeholder": "Busca: Entre com o NOME ou DOCUMENTO do cliente e pressione enter",
      "name": "filtro_pesquisa",
      "type": "text"
    },
    domProps: {
      "value": (_vm.dados.pesquisa)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.getDataTable($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.dados, "pesquisa", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-md-2"
  }, [_c('button', {
    staticClass: "btn btn-default btn-block",
    on: {
      "click": _vm.getDataTable
    }
  }, [_c('i', {
    staticClass: "fa fa-filter"
  }), _vm._v(" Filtrar\n              ")])])]), _vm._v(" "), _c('div', {
    staticClass: "row",
    staticStyle: {
      "margin-top": "15px"
    }
  }, [_c('div', {
    staticClass: "col-sm-12 table-responsive"
  }, [_c('table', {
    staticClass: "table table-bordered table-striped",
    attrs: {
      "aria-describedby": "example1_info",
      "role": "grid",
      "id": "example1"
    }
  }, [_vm._m(1), _vm._v(" "), _c('tbody', _vm._l((_vm.apiData.data), function(item) {
    return _c('tr', {
      key: item.id,
      staticClass: "even",
      attrs: {
        "role": "row"
      }
    }, [_c('td', [_vm._v(_vm._s(_vm._f("dataFormatada")(item.vencimento)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.acordo.pessoa.nome_razao))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.acordo.pessoa.cpf_cnpj))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.parcela) + "/" + _vm._s(item.acordo.numero_parcelas))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.valor))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.situacao))]), _vm._v(" "), _c('td', [_c('button', {
      staticClass: "btn btn-success",
      attrs: {
        "title": "Baixar parcela"
      },
      on: {
        "click": function($event) {
          return _vm.baixarParcela(item.id)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-fw fa-thumbs-o-up"
    })]), _vm._v(" "), _c('button', {
      staticClass: "btn btn-primary",
      attrs: {
        "title": "Detalhes do acordo"
      },
      on: {
        "click": function($event) {
          return _vm.modalAcordoOpen(item)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-fw fa-list"
    })])])])
  }), 0)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-5"
  }, [_vm._v("Mostrando " + _vm._s(this.apiData.from) + " até " + _vm._s(this.apiData.to) + " de " + _vm._s(this.apiData.total) + " registros encontrados.")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-7",
    staticStyle: {
      "text-align": "right"
    }
  }, [_c('laravue-pagination', {
    attrs: {
      "limit": 5,
      "data": _vm.apiData
    },
    on: {
      "pagination-change-page": _vm.getDataTable
    }
  }, [_c('span', {
    attrs: {
      "slot": "prev-nav"
    },
    slot: "prev-nav"
  }, [_vm._v("< Anterior")]), _vm._v(" "), _c('span', {
    attrs: {
      "slot": "next-nav"
    },
    slot: "next-nav"
  }, [_vm._v("Próximo >")])])], 1)])])])])])])]), _vm._v(" "), (_vm.showModalAcordo) ? _c('transition', {
    attrs: {
      "name": "modal"
    }
  }, [_c('div', {
    staticClass: "modal-mask"
  }, [_c('div', {
    staticClass: "modal-container"
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('h3', [_vm._v("Agendamentos dessa pessoa")])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "box box-primary p-10"
  }, [_c('ul', {
    staticClass: "nav nav-tabs",
    attrs: {
      "role": "tablist"
    }
  }, [_c('li', {
    staticClass: "active",
    attrs: {
      "role": "presentation"
    }
  }, [_c('a', {
    attrs: {
      "href": "#acordo",
      "aria-controls": "acordo",
      "role": "tab",
      "data-toggle": "tab"
    }
  }, [_vm._v("Dados do Acordo")])]), _vm._v(" "), _c('li', {
    attrs: {
      "role": "presentation"
    }
  }, [_c('a', {
    attrs: {
      "href": "#agendamento",
      "aria-controls": "agendamento",
      "role": "tab",
      "data-toggle": "tab"
    }
  }, [_vm._v("Agendamentos")])])]), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    staticClass: "tab-content"
  }, [_c('div', {
    staticClass: "tab-pane active",
    attrs: {
      "role": "tabpanel",
      "id": "acordo"
    }
  }, [(_vm.acordoSelecionado) ? _c('table', {
    staticClass: "table table-bordered table-striped",
    attrs: {
      "role": "grid"
    }
  }, [_c('thead', [_c('tr', {
    attrs: {
      "role": "row"
    }
  }, [_c('th', {
    staticStyle: {
      "width": "auto"
    }
  }, [_vm._v("Data Do Acordo")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "auto"
    }
  }, [_vm._v("Pessoa")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "auto"
    }
  }, [_vm._v("Cpf/Cnpj")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "auto"
    }
  }, [_vm._v("Situação")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "auto"
    }
  }, [_vm._v("Valor Total do Acordo")])])]), _vm._v(" "), _c('tbody', [_c('tr', {
    staticClass: "even",
    attrs: {
      "role": "row"
    }
  }, [_c('td', [_vm._v(_vm._s(_vm._f("dataFormatada")(_vm.acordoSelecionado.created_at)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.acordoSelecionado.acordo.pessoa.nome_razao))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.acordoSelecionado.acordo.pessoa.cpf_cnpj))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.acordoSelecionado.acordo.status))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("numberFormat")(_vm.acordoSelecionado.acordo.valor, 2, ',', '.')))])])])]) : _vm._e(), _vm._v(" "), _c('h4', [_vm._v("Parcelas do Acordo")]), _vm._v(" "), (_vm.acordoSelecionado) ? _c('table', {
    staticClass: "table table-bordered table-striped",
    attrs: {
      "role": "grid"
    }
  }, [_c('thead', [_c('tr', {
    attrs: {
      "role": "row"
    }
  }, [_c('th', {
    staticStyle: {
      "width": "auto"
    }
  }, [_vm._v("Vencimento")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "auto"
    }
  }, [_vm._v("Parcela")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "auto"
    }
  }, [_vm._v("Valor")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "auto"
    }
  }, [_vm._v("Situação")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.acordoSelecionado.parcelas), function(item) {
    return _c('tr', {
      key: item.id,
      staticClass: "even",
      attrs: {
        "role": "row"
      }
    }, [_c('td', [_vm._v(_vm._s(_vm._f("dataFormatada")(item.vencimento)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.parcela) + "/" + _vm._s(item.acordo.numero_parcelas))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("numberFormat")(item.valor, 2, ',', '.')))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.situacao))])])
  }), 0)]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12 text-center"
  }, [_c('button', {
    staticClass: "btn btn-danger",
    attrs: {
      "disabled": _vm.acordoSelecionado.acordo.status == 'CANCELADO' ? true : false
    },
    on: {
      "click": function($event) {
        return _vm.cancelar(_vm.acordoSelecionado.acordo.id)
      }
    }
  }, [_vm._v("Cancelar Acordo")])])])]), _vm._v(" "), _c('div', {
    staticClass: "tab-pane",
    attrs: {
      "role": "tabpanel",
      "id": "agendamento"
    }
  }, [(_vm.acordoSelecionado) ? _c('inadimplente-agendamento', {
    attrs: {
      "pessoaId": _vm.acordoSelecionado.acordo.pessoa_id
    }
  }) : _vm._e()], 1)])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('div', {
    staticClass: "text-right",
    staticStyle: {
      "float": "right"
    }
  }, [_c('button', {
    staticClass: "btn btn-default",
    on: {
      "click": function($event) {
        return _vm.modalAcordoClose()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-close"
  }), _vm._v(" Fechar\n            ")])])])])])]) : _vm._e()], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box-header with-border"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_c('b', [_vm._v("Acordos")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', {
    attrs: {
      "role": "row"
    }
  }, [_c('th', {
    staticStyle: {
      "width": "auto"
    }
  }, [_vm._v("Vencimento")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "auto"
    }
  }, [_vm._v("Pessoa")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "auto"
    }
  }, [_vm._v("Cpf/Cnpj")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "auto"
    }
  }, [_vm._v("Parcela")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "auto"
    }
  }, [_vm._v("Valor")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "auto"
    }
  }, [_vm._v("Situação")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "auto"
    }
  }, [_vm._v("Ação")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-05a2eda8"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/cobranca/acordos/acordos.vue
// module id = 382
// module chunks = 1